export interface FieldVisibility {
  [key: string]: boolean;
}
